import { motion } from "framer-motion";
import { Instagram, Youtube, Facebook } from "lucide-react";
import { useLanguage } from "@/i18n";
import { scrollToSection } from "@/scroll";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-line bg-surface/60 overflow-hidden" data-testid="footer-section">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8 pt-24 pb-10">
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-black uppercase leading-[0.9] tracking-tight text-[10.5vw] sm:text-[7.5vw] lg:text-[6rem] text-bone"
        >
          {t.footer.payoffA}
          <br />
          <span className="text-blaze">{t.footer.payoffB}</span>
        </motion.h2>

        <div className="mt-16 pt-8 border-t border-line flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Dust Republic" className="h-16 w-auto" />
          </div>
          <nav className="flex flex-wrap gap-x-7 gap-y-2">
            {[
              { label: t.nav.manifesto, sel: "#manifesto", id: "manifesto" },
              { label: t.nav.pillars, sel: "#pilastri", id: "pillars" },
              { label: t.nav.events, sel: "#eventi", id: "events" },
              { label: t.nav.community, sel: "#community", id: "community" },
            ].map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToSection(l.sel)}
                className="font-telemetry text-[10px] uppercase tracking-[0.22em] text-sandmut hover:text-blaze transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <span className="font-telemetry text-[10px] uppercase tracking-[0.22em] text-faint mr-1">
              {t.footer.follow}
            </span>
            {[
              { Icon: Instagram, id: "instagram", href: "https://instagram.com/dust_republic" },
              { Icon: Youtube, id: "youtube", href: "https://youtube.com" },
              { Icon: Facebook, id: "facebook", href: "https://facebook.com" },
            ].map(({ Icon, id, href }) => (
              <a
                key={id}
                data-testid={`footer-social-${id}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-line p-2 text-sandmut hover:text-blaze hover:border-blaze transition-colors duration-200"
              >
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-telemetry text-[10px] uppercase tracking-[0.18em] text-faint">
            © 2026 {t.footer.rights}
          </p>
          <p className="font-telemetry text-[10px] uppercase tracking-[0.25em] text-faint/70">
            {t.footer.built}
          </p>
        </div>
      </div>
    </footer>
  );
}
